import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import {i18n, mergeI18n} from '@hexabot/chat'
// import Websocket from './utils/vue-sails-websocket'
import longPooling from './utils/longPooling'
import locales from './utils/locales'

mergeI18n(locales)

Vue.use(VueI18n, i18n)
// Websocket
// Vue.use(Websocket, process.env.VUE_APP_API_PATH)

// Long Pooling
Vue.use(longPooling, process.env.VUE_APP_API_PATH + '/webhook/offline?_get=polling&verification_token=' + process.env.VUE_APP_TOKEN)

Vue.config.productionTip = false

export {Vue, VueI18n, i18n}
export default App
